<template>
  <div>
    <div class="col-12">
      <div class="q-mb-md container-adiciona">
        <div
          :class="{
            'opacity-50 cursor-not-allowed': !podeAdicionarExecutante,
          }"
          style="pointer-events: auto"
        >
          <adicionar-executante
            :ptId="pt.ptId"
            :unidade="pt.unidadeId"
            :disabled="!podeAdicionarExecutante"
            @closing="$emit('executantesAtualizados')"
          />
          <q-tooltip v-if="!podeAdicionarExecutante" class="bg-negative">
            Você não tem permissão para Adicionar Executantes
          </q-tooltip>
        </div>
      </div>
      <q-table
        v-if="pt.executantes"
        grid
        :columns="columns"
        :rows="pt.executantes"
        dense
        row-key="executanteId"
        hide-pagination
        :no-data-label="pt.executantes ? '' : 'Nenhum Executante Adicionado'"
      >
        <template v-slot:item="props">
          <div class="q-mb-md table-desktop" style="width: 203px">
            <div v-if="props.row.assinaturas">
              <q-img
                :src="props.row.assinaturas[0].assinatura"
                v-if="
                  !props.row.slideAtivo &&
                  props.row.assinaturas[0].assinaturaTipo == 'manual'
                "
                class="row border-img"
                spinner-color="white"
                height="185px"
                width="185px"
                fit="contain"
                no-native-menu
              >
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'aguardando_assinaturas'
                      : pt.status != 'aguardando_assinaturas' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 5px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="assinaturaExecutante(ptId, props.row.executanteId)"
                />
                <q-btn
                  v-if="props.row.assinaturas"
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  icon="visibility"
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary">
                    {{
                      props.row.mostrandoAssinatura
                        ? "Ocultar Assinatura"
                        : "Visualizar Assinatura"
                    }}
                  </q-tooltip>
                </q-btn>
                <q-btn
                  :disable="!podeRemoverExecutante(props.row)"
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  size="md"
                  icon="delete"
                  @click="removerExecutante(props.row.executanteId)"
                >
                  <q-tooltip
                    v-if="!podeRemoverExecutante(props.row)"
                    class="bg-negative"
                  >
                    Você não tem permissão para Remover
                  </q-tooltip>
                </q-btn>
              </q-img>

              <q-img
                v-if="
                  props.row.assinaturas[0].assinaturaTipo == 'eletronica' &&
                  !props.row.slideAtivo
                "
                class="border-img container"
                no-native-menu
              >
                <span class="text-brand-5 text-weight-bold teste2"
                  >Assinatura Eletrônica
                </span>
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'aguardando_assinaturas'
                      : pt.status != 'aguardando_assinaturas' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 5px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="assinaturaExecutante(ptId, props.row.executanteId)"
                />
                <q-btn
                  :disable="!podeRemoverExecutante(props.row)"
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  size="md"
                  icon="delete"
                  @click="removerExecutante(props.row.executanteId)"
                >
                  <q-tooltip
                    v-if="!podeRemoverExecutante(props.row)"
                    class="bg-negative"
                  >
                    Você não tem permissão para Remover
                  </q-tooltip>
                </q-btn>
              </q-img>

              <q-img
                v-else-if="
                  ['biometrica', 'facial'].includes(
                    props.row.assinaturas[0].assinaturaTipo
                  ) &&
                  props.row.mostrandoAssinatura &&
                  props.row.assinaturaImagem &&
                  !props.row.slideAtivo
                "
                :src="props.row.assinaturaImagem"
                class="border-img"
                spinner-color="white"
                height="185px"
                width="185px"
                fit="contain"
                no-native-menu
              >
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'aguardando_assinaturas'
                      : pt.status != 'aguardando_assinaturas' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 5px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="assinaturaExecutante(ptId, props.row.executanteId)"
                />
                <q-btn
                  v-if="props.row.assinaturas"
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  icon="visibility"
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary">
                    {{
                      props.row.mostrandoAssinatura
                        ? "Ocultar Assinatura"
                        : "Visualizar Assinatura"
                    }}
                  </q-tooltip>
                </q-btn>
                <q-btn
                  :disable="!podeRemoverExecutante(props.row)"
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  size="md"
                  icon="delete"
                  @click="removerExecutante(props.row.executanteId)"
                >
                  <q-tooltip
                    v-if="!podeRemoverExecutante(props.row)"
                    class="bg-negative"
                  >
                    Você não tem permissão para Remover
                  </q-tooltip>
                </q-btn>
              </q-img>

              <q-img
                v-else-if="
                  ['biometrica', 'pin', 'token', 'facial', 'cracha'].includes(
                    props.row.assinaturas[0].assinaturaTipo
                  ) && !props.row.slideAtivo
                "
                class="border-img container"
                no-native-menu
              >
                <span class="text-brand-5 text-weight-bold teste2">
                  {{
                    props.row.assinaturas[0].assinaturaTipo === "cracha"
                      ? "Autenticado por Crachá"
                      : props.row.assinaturas[0].assinaturaTipo === "facial"
                      ? "Biometria Facial"
                      : props.row.assinaturas[0].assinaturaTipo === "biometrica"
                      ? "Biometria Digital"
                      : props.row.assinaturas[0].assinaturaTipo === "pin"
                      ? "Autenticado por PIN"
                      : props.row.assinaturas[0].assinaturaTipo === "token"
                      ? "Autenticado por Token"
                      : "Assinado Eletrônicamente"
                  }}
                </span>
                <q-btn
                  :disable="
                    usuarioPodeEditar
                      ? pt.status != 'aguardando_assinaturas'
                      : pt.status != 'aguardando_assinaturas' ||
                        usuario != props.row.matricula
                  "
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; left: 5px"
                  text-color="dark"
                  round
                  flat
                  size="md"
                  icon="history_edu"
                  @click="assinaturaExecutante(ptId, props.row.executanteId)"
                />
                <q-btn
                  v-if="props.row.assinaturas"
                  color="white"
                  class="absolute all-pointer-events cursor"
                  style="bottom: 0px; left: 50%; transform: translateX(-50%)"
                  text-color="primary"
                  flat
                  round
                  size="sm"
                  icon="visibility"
                  @click="toggleAssinaturaView(props.row)"
                >
                  <q-tooltip class="bg-primary">
                    {{
                      props.row.mostrandoAssinatura
                        ? "Ocultar Assinatura"
                        : "Visualizar Assinatura"
                    }}
                  </q-tooltip>
                </q-btn>
                <q-btn
                  :disable="!podeRemoverExecutante(props.row)"
                  class="absolute all-pointer-events cursor"
                  color="white"
                  style="bottom: 0px; right: 1px"
                  text-color="red"
                  round
                  flat
                  size="md"
                  icon="delete"
                  @click="removerExecutante(props.row.executanteId)"
                >
                  <q-tooltip
                    v-if="!podeRemoverExecutante(props.row)"
                    class="bg-negative"
                  >
                    Você não tem permissão para Remover
                  </q-tooltip>
                </q-btn>
              </q-img>

              <div class="border-img" v-if="props.row.slideAtivo">
                <q-carousel
                  v-model="props.row.slide"
                  transition-prev="slide-right"
                  transition-next="slide-left"
                  swipeable
                  animated
                  control-color="black"
                  padding
                  arrows
                  height="100%"
                  flat
                  class="rounded-borders"
                >
                  <q-carousel-slide
                    v-for="(assinaturas, index) in props.row.assinaturas"
                    :key="index"
                    :name="index"
                    style="padding: 10px"
                  >
                    <div class="row absolute-top justify-center custom-caption">
                      <div class="text-brand-5 text-weight-bold">
                        {{ assinaturas.atividadeNome }}
                      </div>
                    </div>
                    <div class="row fit justify-center items-center">
                      <q-img
                        v-if="assinaturas.assinaturaTipo == 'manual'"
                        width="185px"
                        :src="assinaturas.assinatura"
                      >
                      </q-img>
                      <q-img v-else no-native-menu class="container">
                        <span
                          class="text-brand-5 text-weight-bold assinatura-eletronica"
                          >Assinatura Eletrônica</span
                        >
                      </q-img>
                    </div>
                  </q-carousel-slide>
                  <template v-slot:control>
                    <q-carousel-control
                      position="bottom-right"
                      :offset="[0, 0]"
                      class="q-gutter-xs"
                    >
                      <q-btn
                        :disable="!podeRemoverExecutante(props.row)"
                        class="absolute all-pointer-events cursor"
                        color="white"
                        style="bottom: 0px; right: 1px"
                        text-color="red"
                        round
                        flat
                        size="md"
                        icon="delete"
                        @click="removerExecutante(props.row.executanteId)"
                      >
                        <q-tooltip
                          v-if="!podeRemoverExecutante(props.row)"
                          class="bg-negative"
                        >
                          Você não tem permissão para Remover
                        </q-tooltip>
                      </q-btn>
                    </q-carousel-control>
                    <q-carousel-control
                      position="bottom-left"
                      :offset="[0, 0]"
                      class="q-gutter-xs"
                    >
                      <q-btn
                        :disable="
                          usuarioPodeEditar
                            ? pt.status != 'aguardando_assinaturas'
                            : pt.status != 'aguardando_assinaturas' ||
                              usuario != props.row.matricula
                        "
                        class="absolute all-pointer-events cursor"
                        color="white"
                        style="bottom: 0px; left: 1px"
                        text-color="dark"
                        round
                        flat
                        size="md"
                        icon="history_edu"
                        @click="
                          assinaturaExecutante(ptId, props.row.executanteId)
                        "
                      />
                    </q-carousel-control>
                  </template>
                </q-carousel>
              </div>
            </div>
            <q-img v-else class="border-img container" no-native-menu>
              <span
                class="text-brand-5 text-weight-bold teste"
                style="font-size: 18px"
                >Sem Assinatura</span
              >

              <q-btn
                :disable="
                  usuarioPodeEditar
                    ? pt.status != 'aguardando_assinaturas'
                    : pt.status != 'aguardando_assinaturas' ||
                      usuario != props.row.matricula
                "
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; left: 1px"
                text-color="dark"
                round
                flat
                size="md"
                icon="history_edu"
                @click="assinaturaExecutante(ptId, props.row.executanteId)"
              />
              <q-btn
                :disable="!podeRemoverExecutante(props.row)"
                class="absolute all-pointer-events cursor"
                color="white"
                style="bottom: 0px; right: 1px"
                text-color="red"
                round
                flat
                size="md"
                icon="delete"
                @click="removerExecutante(props.row.executanteId)"
              >
                <q-tooltip
                  v-if="!podeRemoverExecutante(props.row)"
                  class="bg-negative"
                >
                  Você não tem permissão para Remover
                </q-tooltip>
              </q-btn>
            </q-img>

            <div class="col-4">
              <q-toggle
                v-model="props.row.slideAtivo"
                color="positive"
                label="Mostrar todas assinaturas"
                class="toggle-assinatura"
                keep-color
              />
            </div>
            <div
              class="row col-12 q-mt-sm items-center"
              style="background: #ffe9e9; width: 90%"
              v-if="!props.row.assinaturas"
            >
              <span class="elipse q-mr-sm bg-red"></span>
              <span class="text-weight-bold text-red texto-assinatura">
                Assinatura NÃO Coletada</span
              >
            </div>
            <div
              class="row col-12 q-mt-sm items-center"
              style="background: #e8ffec; width: 90%"
              v-if="props.row.assinaturas"
            >
              <span class="elipse q-mr-sm bg-positive"></span>
              <span class="text-weight-bold text-brand-5 texto-assinatura">
                Assinatura Coletada</span
              >
            </div>

            <q-card-section
              style="width: 200px; margin-top: 5px; padding: 0"
              class="row text-weight-regular text-body2"
            >
              <div class="column text-brand-5 text-weight-regular">
                <span class="q-mb-sm">{{ props.row.nome }}</span>

                <span class="q-mb-sm text-brand-5 text-weight-bold">
                  <div class="text-brand-5 text-weight-regular">
                    <div class="texto text-brand-5 text-weight-bold">
                      Matricula:
                    </div>
                    {{ props.row.matricula }}
                  </div>
                </span>

                <span class="q-mb-sm text-brand-5 text-weight-bold">
                  <div class="text-weight-regular">
                    <div class="texto text-brand-5 text-weight-bold">
                      Empresa:
                    </div>
                    {{ props.row.empresa }}
                  </div>
                </span>

                <span class="text-brand-5 text-weight-bold">
                  <div class="text-weight-regular">
                    <div class="texto text-brand-5 text-weight-bold">
                      Terceirizado:
                    </div>
                    {{ props.row.terceirizado ? "Sim" : "Não" }}
                  </div>
                </span>
              </div>
            </q-card-section>
          </div>
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4 mobileGrid">
            <div class="row card q-mb-md justify-around">
              <div class="col-7 q-mr-sm q-mt-sm">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div
                    class="row col-12"
                    style="background: #e8ffec; width: 90%"
                    v-if="props.row.assinaturas"
                  >
                    <span class="elipse q-mr-sm bg-positive"></span>
                    <span
                      class="text-weight-bold text-brand-5 texto-assinatura"
                    >
                      Assinatura Coletada</span
                    >
                  </div>
                  <div
                    class="row col-12"
                    style="background: #ffe9e9; width: 90%"
                    v-else
                  >
                    <span class="elipse q-mr-sm bg-red"></span>
                    <span class="text-weight-bold text-red texto-assinatura">
                      Assinatura NÃO Coletada</span
                    >
                  </div>
                  <div class="col-12">
                    <span> {{ props.row.nome }}</span>
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Matricula:</strong>
                      {{ props.row.matricula }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span><strong>Tipo:</strong> {{ props.row.tipo }}</span>
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Terceiro:</strong>
                      {{ props.row.terceirizado ? "Sim" : "Não" }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Terceiro:</strong> {{ props.row.empresa }}</span
                    >
                  </div>
                </q-card-section>
              </div>
              <div
                class="col q-ml-sm justify-center q-mt-sm text-brand-5 text-weight-bold text-grid-table"
              >
                <div class="q-ml-lg">Assinatura</div>
                <div
                  style="width: 120px; height: 80px"
                  class="row items-center justify-center"
                >
                  <div class="carrosel-container">
                    <q-carousel
                      v-model="props.row.slide"
                      transition-prev="slide-right"
                      transition-next="slide-left"
                      swipeable
                      animated
                      control-color="black"
                      height="100%"
                      flat
                      class="rounded-borders"
                    >
                      <q-carousel-slide
                        v-for="(assinaturas, index) in props.row.assinaturas"
                        :key="index"
                        :name="index"
                        style="padding: 0px"
                      >
                        <div class="row justify-center custom-caption">
                          <div
                            class="text-brand-5 text-weight-bold"
                            style="font-size: 10px"
                          >
                            {{ assinaturas.atividadeNome }}
                          </div>
                        </div>
                        <div
                          class="row fit justify-center items-center"
                          style="height: 90px; width: 120px"
                        >
                          <q-img
                            v-if="assinaturas.assinaturaTipo == 'manual'"
                            :src="assinaturas.assinatura"
                          >
                          </q-img>
                          <q-img
                            v-else-if="
                              ['biometrica', 'facial'].includes(
                                assinaturas.assinaturaTipo
                              ) &&
                              props.row.mostrandoAssinatura &&
                              props.row.assinaturaImagem
                            "
                            :src="props.row.assinaturaImagem"
                            fit="contain"
                          >
                          </q-img>
                          <span
                            style="font-size: 10px; height: 70px"
                            class="q-mt-md"
                            v-else-if="
                              assinaturas.assinaturaTipo == 'eletronica'
                            "
                            >Assinatura Eletrônica</span
                          >
                          <span
                            style="font-size: 10px; height: 70px"
                            class="q-mt-md"
                            v-else
                          >
                            {{
                              assinaturas.assinaturaTipo === "cracha"
                                ? "Autenticado por Crachá"
                                : assinaturas.assinaturaTipo === "facial"
                                ? "Biometria Facial"
                                : assinaturas.assinaturaTipo === "biometrica"
                                ? "Biometria Digital"
                                : assinaturas.assinaturaTipo === "pin"
                                ? "Autenticado por PIN"
                                : assinaturas.assinaturaTipo === "token"
                                ? "Autenticado por Token"
                                : "Assinatura Eletrônica"
                            }}
                          </span>
                        </div>
                      </q-carousel-slide>
                    </q-carousel>
                  </div>
                </div>
              </div>
              <div class="row col-12">
                <div class="column col-4">
                  <q-btn
                    :disable="
                      usuarioPodeEditar
                        ? pt.status != 'aguardando_assinaturas'
                        : pt.status != 'aguardando_assinaturas' ||
                          usuario != props.row.matricula
                    "
                    class="btn-grid"
                    label="Assinatura"
                    icon="history_edu"
                    stack
                    style="background: #393939; color: white"
                    no-caps
                    @click="assinaturaExecutante(ptId, props.row.executanteId)"
                  />
                </div>
                <div class="column col-4" v-if="props.row.assinaturas">
                  <q-btn
                    class="btn-grid"
                    :label="
                      props.row.assinaturas[0].assinaturaTipo === 'manual'
                        ? props.row.ocultarAssinatura
                          ? 'Mostrar'
                          : 'Ocultar'
                        : props.row.mostrandoAssinatura
                        ? 'Ocultar'
                        : 'Ver'
                    "
                    icon="visibility"
                    stack
                    style="background: #1976d2; color: white"
                    no-caps
                    @click="toggleAssinaturaView(props.row)"
                  />
                </div>
                <div class="column col-4">
                  <q-btn
                    :disable="!podeRemoverExecutante(props.row)"
                    class="btn-grid"
                    label="Deletar"
                    icon="delete"
                    stack
                    style="background: #cf1515; color: white"
                    no-caps
                    @click="removerExecutante(props.row.executanteId)"
                  >
                    <q-tooltip
                      v-if="!podeRemoverExecutante(props.row)"
                      class="bg-negative"
                    >
                      Você não tem permissão para Remover
                    </q-tooltip>
                  </q-btn>
                </div>
              </div>
            </div>
          </div>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import AdicionarExecutante from "./AdicionarExecutante.vue";
import { useRouter } from "vue-router";
import { ref, computed } from "vue";

const columns = [
  {
    name: "nome",
    align: "left",
    label: "Nome",
    field: "nome",
    sortable: true,
  },
  {
    name: "matricula",
    align: "left",
    label: "Matricula",
    field: "matricula",
    sortable: true,
  },
  {
    name: "empresa",
    align: "left",
    label: "Empresa",
    field: "empresa",
    sortable: false,
  },
  {
    name: "terceirizado",
    label: "terceirizado",
    align: "left",
    field: "terceirizado",
    sortable: false,
    format: (val) => {
      return val ? "sim" : "não";
    },
  },
  {
    name: "remover",
    label: "Remover",
    align: "center",
    field: "executanteId",
    sortable: false,
  },
  {
    name: "assinaturas",
    label: "Assinaturas",
    align: "center",
    field: "responsavelId",
    sortable: false,
  },
  {
    name: "foto",
    label: "Upload Foto",
    align: "center",
    field: "responsavelId",
    sortable: false,
  },
];
export default {
  props: [
    "pt",
    "usuarioPodeEditar",
    "usuarioPodeAdicionarUser",
    "usuarioPodeRemoverUser",
  ],
  emits: ["executantesAtualizados"],
  components: { AdicionarExecutante },
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    let executanteId = ref(null);
    const usuario = store.getters["autenticacao/usuarioLogado"].id;

    const removerExecutante = async (executanteId) => {
      try {
        await store.dispatch("pdt/removerExecutantePt", {
          ptId: props.pt.ptId,
          executanteId,
        });

        emit("executantesAtualizados");
        quasar.notify({
          message: "Executante removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Ocorreu um erro ao remover executante",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const assinaturaExecutante = (ptId, executanteId) => {
      router.push({
        name: "pdt-pt-assinatura-executante",
        params: ({ ptId }, { executanteId }),
      });
    };

    const podeRemoverExecutante = () => {
      if (props.pt.status === "aberto") {
        return props.usuarioPodeEditar;
      }

      if (props.pt.status === "aguardando_assinaturas") {
        return props.usuarioPodeEditar && props.usuarioPodeRemoverUser;
      }

      if (props.pt.status === "iniciado") {
        return props.usuarioPodeEditar && props.usuarioPodeRemoverUser;
      }

      return false;
    };

    const podeAdicionarExecutante = computed(() => {
      if (props.pt.status === "aberto") {
        return props.usuarioPodeEditar;
      }

      if (props.pt.status === "aguardando_assinaturas") {
        return props.usuarioPodeEditar && props.usuarioPodeAdicionarUser;
      }

      if (props.pt.status === "iniciado") {
        return props.usuarioPodeEditar && props.usuarioPodeAdicionarUser;
      }

      return false;
    });

    const toggleAssinaturaView = async (executante) => {
      if (!executante.assinaturas || !executante.assinaturas[0]) {
        return;
      }

      const assinatura = executante.assinaturas[0];

      // Para assinatura manual, apenas oculta/mostra
      if (assinatura.assinaturaTipo === "manual") {
        // Força a reatividade usando Vue.set se necessário
        if (typeof executante.ocultarAssinatura === "undefined") {
          executante.ocultarAssinatura = false;
        }
        executante.ocultarAssinatura = !executante.ocultarAssinatura;
        return;
      }

      // Para outros tipos, se já está mostrando, apenas oculta
      if (executante.mostrandoAssinatura) {
        executante.mostrandoAssinatura = false;
        executante.assinaturaImagem = null;
        return;
      }

      // Para métodos que precisam processar (biometria, facial)
      if (["biometrica", "facial"].includes(assinatura.assinaturaTipo)) {
        // Inicializa propriedades se não existirem
        if (typeof executante.carregandoAssinatura === "undefined") {
          executante.carregandoAssinatura = false;
        }
        if (typeof executante.erroAssinatura === "undefined") {
          executante.erroAssinatura = false;
        }
        if (typeof executante.mostrandoAssinatura === "undefined") {
          executante.mostrandoAssinatura = false;
        }
        if (typeof executante.assinaturaImagem === "undefined") {
          executante.assinaturaImagem = null;
        }

        executante.carregandoAssinatura = true;
        executante.erroAssinatura = false;

        try {
          // Usa o endpoint correto para obter a URL assinada
          const response = await store.dispatch("pdt/getImage", {
            url: assinatura.assinatura,
          });

          // Atualiza a imagem assinada diretamente no objeto - forçando reatividade
          const imageUrl = response.data.resultado.dados;

          // Usa Vue.set para garantir reatividade ou Object.assign
          Object.assign(executante, {
            assinaturaImagem: imageUrl,
            mostrandoAssinatura: true,
          });
        } catch (error) {
          console.error("Erro ao carregar imagem:", error);
          executante.erroAssinatura = true;

          quasar.notify({
            message: "Erro ao visualizar imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
        } finally {
          executante.carregandoAssinatura = false;
        }
      } else {
        // Para outros métodos eletrônicos (token, pin), apenas mostra confirmação
        if (typeof executante.mostrandoAssinatura === "undefined") {
          executante.mostrandoAssinatura = false;
        }
        executante.mostrandoAssinatura = true;
      }
    };

    return {
      columns,
      removerExecutante,
      executanteId,
      assinaturaExecutante,
      usuario,
      slide: ref(0),
      podeRemoverExecutante,
      podeAdicionarExecutante,
      toggleAssinaturaView,
    };
  },
};
</script>

<style scoped>
img {
  height: 200px;
  width: 300px;
}
.border-img {
  border: 1px solid #b4b4b4;
  border-radius: 5px;
  height: 185px;
  width: 185px;
}
.cursor {
  cursor: pointer;
}
.texto {
  display: inline;
}
.container {
  position: relative;
}
.teste {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
  text-align: center;
  width: 90%;
}
.teste2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
  font-size: 15px;
  text-align: center;
  width: 90%;
}
.assinatura-eletronica {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
  font-size: 15px;
  text-align: center;
  width: 90%;
}
.container1 {
  position: relative;
}
.text-assinatura {
  position: absolute;
}
.toggle-assinatura {
  font-size: 11px;
  color: #58c16d;
}
.mobileGrid {
  display: none;
}
.texto-assinatura {
  font-size: 13px;
}
@media (max-width: 600px) {
  .container-adiciona {
    margin-left: 10px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .assinatura-nome {
    font-size: 10px;
  }
  .carrosel-container {
    width: 200px;
    overflow: hidden;
  }
  .mobileGrid {
    display: block;
  }
  .table-desktop {
    display: none;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-grid {
    font-size: 12px;
    border-radius: 0px;
  }
  .texto-assinatura {
    font-size: 10px;
  }
  .elipse {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    padding: 0px;
    margin: 2px 5px 0px 0px;
  }
}
</style>
